export default function HeroSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      {/* Background pattern */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-500/5 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-500/5 blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left text content */}
          <div className="w-full lg:w-1/2 flex flex-col items-start">
            {/* Tag */}
            <div className="inline-flex items-center gap-2 bg-primary-500/10 border border-primary-500/20 rounded-full px-4 py-1.5 mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-xs font-medium text-primary-400 whitespace-nowrap">7×24h 持续更新 · 免费高清观看</span>
            </div>

            {/* H1 */}
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              黑料
              <span className="text-primary-400"> — 不打烊在线观看平台</span>
            </h1>

            {/* Slogan */}
            <p className="mt-3 text-lg md:text-xl text-accent-400 font-medium">
              每日大赛 · 新鲜视频 · 随时随地畅享
            </p>

            {/* Intro */}
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              黑料不打烊在线观看平台每日持续更新海量黑料在线视频，覆盖黑料每日大赛、热门话题追踪、
              娱乐八卦速递等多元内容板块。无论是最新黑料不打烊热门视频，还是全网热传的精彩片段，
              在这里都能免费高清观看，真正做到24小时不打烊。
            </p>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              当前热门：<strong className="text-foreground-800">#明星八卦最新动态</strong>、<strong className="text-foreground-800">#综艺节目精彩cut</strong>、
              <strong className="text-foreground-800">#网红达人热门事件</strong> 持续刷屏中，立即加入观看！
            </p>

            {/* Stats */}
            <div className="flex flex-wrap items-center gap-6 md:gap-8 mt-7">
              <div className="flex flex-col">
                <span className="text-2xl md:text-3xl font-heading font-bold text-primary-400">200+</span>
                <span className="text-xs text-foreground-500 mt-1">每日更新视频</span>
              </div>
              <div className="w-px h-10 bg-background-300/50"></div>
              <div className="flex flex-col">
                <span className="text-2xl md:text-3xl font-heading font-bold text-accent-400">12</span>
                <span className="text-xs text-foreground-500 mt-1">大话题板块</span>
              </div>
              <div className="w-px h-10 bg-background-300/50"></div>
              <div className="flex flex-col">
                <span className="text-2xl md:text-3xl font-heading font-bold text-primary-400">全平台</span>
                <span className="text-xs text-foreground-500 mt-1">免费高清观看</span>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mt-8">
              <a
                href="#cards"
                onClick={(e) => handleNavClick(e, '#cards')}
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold px-6 py-3 rounded-lg text-sm transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看热门精选
              </a>
              <a
                href="#app"
                onClick={(e) => handleNavClick(e, '#app')}
                className="inline-flex items-center gap-2 bg-background-200 hover:bg-background-300 text-foreground-800 font-medium px-6 py-3 rounded-lg text-sm transition-all border border-background-300/50 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-smartphone-line text-lg"></i>
                下载手机客户端
              </a>
            </div>
          </div>

          {/* Right visual */}
          <div className="w-full lg:w-1/2 flex items-center justify-center">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100 border border-background-300/30">
              <img
                src="https://readdy.ai/api/search-image?query=Dynamic%20abstract%20entertainment%20media%20platform%20visual%2C%20dark%20atmospheric%20background%20with%20warm%20crimson%20and%20amber%20glowing%20accent%20lights%2C%20digital%20streaming%20aesthetic%2C%20modern%20sleek%20design%2C%20play%20button%20motif%2C%20cinematic%20vibe%2C%20clean%20minimalist%20composition%20with%20bold%20color%20contrast%2C%20professional%20entertainment%20industry%20atmosphere&width=800&height=600&seq=hero-visual-main&orientation=landscape"
                alt="黑料不打烊在线观看平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-background-50/40 via-transparent to-transparent"></div>
              {/* Floating badge */}
              <div className="absolute top-4 right-4 bg-background-950/90 backdrop-blur-sm rounded-lg px-4 py-2 border border-primary-500/20">
                <div className="flex items-center gap-2">
                  <i className="ri-live-line text-primary-400 text-lg"></i>
                  <span className="text-xs font-medium text-foreground-800 whitespace-nowrap">直播中 · 2.3万观看</span>
                </div>
              </div>
              {/* Floating stat */}
              <div className="absolute bottom-4 left-4 bg-background-950/90 backdrop-blur-sm rounded-lg px-4 py-2 border border-accent-500/20">
                <div className="flex items-center gap-2">
                  <i className="ri-fire-line text-accent-400 text-lg"></i>
                  <span className="text-xs font-medium text-foreground-800 whitespace-nowrap">今日热门 · TOP 1</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}